module.exports = __webpack_public_path__ + "img/carrousel-rad-conv-mov-3.1591f688.png";